import { createSelector } from '@reduxjs/toolkit';
import { FOfferType } from '../../../../packages/JsonQuery';
import { selectIsByHomeowner, selectOfferType } from 'shared/selectors/jsonQuery';

export const selectDealTypeFilter = createSelector([selectIsByHomeowner, selectOfferType], (value, offerType) => ({
  label: 'Тип сделки',
  value,
  visible: (offerType & (FOfferType.Residential & ~FOfferType.FlatNew)) !== 0,
}));
